import { PickupData } from "@redotech/redo-model/draft-return/draft-return";
import { PickupLocation } from "@redotech/redo-model/return";
import { pickupLocationOptions } from "@redotech/redo-model/return-flow";
import { useMemo, useState } from "react";

export const useLocationPickerState = (
  shippingDetails: { pickupData: PickupData },
  updatePickupInfo: (updates: Partial<PickupData>) => void,
) => {
  const [locationPickerOpen, setLocationPickerOpen] = useState(false);

  const locationOptions = useMemo(() => {
    return Array.from(pickupLocationOptions().values()).map((option) => ({
      id: option.value,
      value: option.value,
      type: "text",
      text: option.label,
    }));
  }, []);

  const selectedLocationItem = useMemo(() => {
    if (!shippingDetails) return undefined;
    const selectedLocation =
      shippingDetails.pickupData.pickupLocation.packageLocation;
    return locationOptions.find((item) => item.value === selectedLocation);
  }, [shippingDetails, locationOptions]);

  const handleLocationSelection = (selectedLocation: PickupLocation) => {
    updatePickupInfo({ pickupLocation: { packageLocation: selectedLocation } });
  };

  return {
    open: locationPickerOpen,
    setOpen: setLocationPickerOpen,
    locationOptions,
    selectedLocationItem,
    handleLocationSelection,
  };
};
